import { useQuery } from "react-query";
import { useIntl } from "react-intl";
import useGlobalContext from "hooks/globalData";
import{ AutocompleteWithQuery } from "@knowfully/ui.common";
import { AutocompleteWithQueryProps } from "@knowfully/ui.common/components/AutocompleteWithQuery";
import {
  IdNameModel,
  ListRequestOfBaseFilter,
} from "services/organizationPortalClient";

type SelectEnrollmentStatusProps = Omit<
  AutocompleteWithQueryProps<IdNameModel>,
  "fetchedData" | "failMessage" | "labelField"
>;

export default function SelectEnrollmentStatus({
  ...rest
}: SelectEnrollmentStatusProps) {
  const { formatMessage: t } = useIntl();
  const { enrollmentService } = useGlobalContext();

  const data = useQuery(["enrollment-statuses"], () =>
    enrollmentService.getEnrollmentStatuses(
      ListRequestOfBaseFilter.fromJS({ sortField: "name" })
    )
  );

  return (
    <AutocompleteWithQuery
      {...rest}
      size="small"
      labelField="name"
      fetchedData={data}
      label={t({ id: "status" })}
      failMessage={t({ id: "fetchError" })}
    />
  );
}
